export const URL = {
  BASE_API_URL: process.env.REACT_APP_BASE_API_URL ?? '',
  BASE_API_URL_IAGRI: process.env.REACT_APP_BASE_API_URL_IAGRI ?? '',
  TASK_API_URL: process.env.REACT_APP_TASK_MANAGEMENT_API_URL ?? '',
  LEAD_API_URL: process.env.REACT_APP_LEAD_MANAGEMENT_API_URL ?? '',
  LEAVE_API_URL: process.env.REACT_APP_LEAVE_MANAGEMENT_API_URL ?? '',
  BASE_URL_KSHEMA: process.env.REACT_APP_BASE_URL_KSHEMA ?? '',
  BASE_URL_REST_FULL_ITUS: process.env.REACT_APP_BASE_URL_REST_FULL_ITUS ?? '',
  BASE_PREPORD_URL: process.env.REACT_APP_BASE_URL_KSHEMA ?? '',
  MARKETING_ACTIVITY_API_URL:
    process.env.REACT_APP_MARKETING_ACTIVITY_API_URL ?? '',
  REMUNERATIONS_API_URL:
    process.env.REACT_APP_TASK_MANAGEMENT_API_URL + '/remuneration',
  TRACK_COMPLAINTS_API_URL:
    process.env.REACT_APP_TRACK_COMPLAINTS_API_URL ?? '',
  POWERBI_API: 'https://api.powerbi.com/v1.0/myorg',
  LIST_OF_EMPLOYEES_STATUS: 'api/getActiveEmployeesList',
  CANDIDATE_COMPLETE_DETAILS: 'api/candidateCompleteDetails',
  KYC_DOCUMENT_DETAILS: 'api/documents-details',
  GET_EXTERNAL_EMPLOYEES_LIST: 'api/getExternalEmployeesList',
  UPDATE_REGISTRATION_STATUS: 'api/registrationApproval',
  EMPLOYEE_ASSIGN_GRID: 'api/employee-grid-mapping',
  REPORTING_MANAGER_GRID: 'api/getReportingManagerDetails',
  TASK_LIST: 'getTaskList',
  IEC_TASK_TYPE: 'getIECTaskTypeList',
  CREATE_TASK: 'createTask',
  TASK_DETAILS: 'getTaskDetails',
  ASSIGN_TASK: 'taskAssign',
  UPDATE_TASK_STATUS: 'taskStatusUpdate',
  TASK_NAME_DROPS: 'masters/getTaskNameDrop',
  ROLES_CUSTOM_DROPS: 'task-assignable-roles',
  APPROVE_REJECT_TASK: 'taskApproval',
  STATUS_DROPS: 'masters/getStatusDrop',
  EMPLOYEE_NAME_DROPS: 'api/getEmployeeDrop',
  UPDATE_KYC_STATUS: 'update-registration/kycApproval',
  REMOVE_ASSIGNED_GRID: 'api/removeGrid',
  POST_SSO_VALIDATION: 'authn/postSSOValidation',
  LOGOUT: 'authn/logoutUser',
  CREATE_NOTE: 'notes/createNew',
  UPDATE_CANDIDATE_NAME: 'api/update-user-name',
  LAST_LOCATION_LIST: 'tracking/getEmployeesLastLocationList',
  TRACKING_HISTORY: 'tracking/getEmployeeTrackingHistory',
  ROLES_DROP: 'masters/getRolesDrop',
  ALL_ROLES_DROP: 'masters/getAllRoles',
  LEAD_LIST: 'getLeadsList',
  CREATE_LEAD: 'createLead',
  LEAD_DETAILS: 'getLeadDetails',
  ASSIGN_LEAD: 'leadAssign',
  LEAD_STATUS_UPDATE: 'leadStatusUpdate',
  LEAD_TYPE_DROP: 'masters/getLeadTypeDrop',
  LEAD_TYPE_PRODUCTS: 'masters/getLeadProducts',
  LEAD_TYPE_BANK: 'masters/getLeadsBanks',
  LEAD_TYPE_BRANCH: 'masters/getLeadsBranch',
  LEAD_TYPE_DROPDOWN: '/dropdownItems',
  TARGET_DROP: 'masters/getpickListDrop',
  TARGET_LIST: 'salesTarget/getTargets',
  MASTER_GET_TARGETS: 'masters/getSetTargetMasterData',
  SET_TARGET: 'salesTarget/setTargets',
  ATTENDANCE_LIST: 'attendanceService/getAttendanceList',
  ATTENDANCE_DETAILS: 'attendanceService/getAttendanceDetails',
  LEAVE_TYPE_DROP: 'masters/getLeaveTypeDrop',
  ATTENDANCE_APPROVE: 'attendanceService/attendanceApproval',
  LEAVE_LIST: 'leaveService/getLeavesHistoryList',
  PENDING_LEAVE_LIST: 'leaveService/getLeavesPendingList',
  LEAVE_DETAILS: 'leaveService/leaveDetails',
  APPROVE_REJECT_LEAVE: 'leaveService/leaveApproval',
  MA_EMPLOYEE_LIST: 'master/getEmployeeList',
  MA_LIST: 'getAllList',
  DETAILED_MA: 'getDetails',
  CREATE_MA: 'addNew',
  APPROVE_REJECT_MA: 'approveRequest',
  REMOVE_ASSIGNEE_MA: 'revokeEmployee',
  ADD_ASSIGNEES_MA: 'assignEmployee',
  UPDATE_PRIMARY_EMPLOYEE: 'updatePrimaryEmployee',
  REMUNERATION_LIST: 'userRemunerationList',
  DETAILED_REMUNERATION: 'getDetails',
  APPROVE_REJECT_REMUNERATION: 'approval',
  ADD_MEDIA: 'addMedia',
  TRACK_COMPLAINTS_LIST: 'getComplaintList',
  DETAILED_COMPLAINT: 'getComplaintDetails',
  SEVERITY_TYPES: 'masters/getSeverityTypes',
  COMPLAINT_ASSIGN: 'complaintAssign',
  APPROVE_REIMBURSMENT_LIST: 'claims/getAllList',
  APPLY_REIMBURSMENT: 'claims/applyNewClaim',
  REIMBURSEMENT_DETAILS: 'claims/getDetails',
  APPROVE_REIMBURSMENT: 'claims/approveRequest',
  REIMBURSMENT_ATTACHMENTS: 'claims/attachFiles',
  REIMBURSEMENT_LOCATIONS: 'claims/getLocationDetails',
  VEHICLE_DETAILS: '/vehical-details',

  //** KSHEMA APIS **/
  PINCODE_GRIDS: 'api/grid-list-drop',
  PINCODE: 'pincode',
  LOGIN_V: 'loginv',
  PAN_STATUS: 'panstatus',
  AADHAR_STATUS: 'aadharstatus',
  QUALIFICATION_STATUS: 'qulstatus',
  BANK_STATUS: 'bankstatus',
  ZONES_DROP: 'location/zone-state',
  PINCODE_DROP: 'location/searchByPincode',
  VILLAGE_DROP: 'location/district-cities',
  VILLAGE_PINCODE_GRIDS: 'api/grid-list-drop',
  //** END OF KSHEMA APIS **/

  /** Banner */
  BANNER_GET_ALL_LIST: 'homeBanner/getAllList',
  BANNER_ADD_NEW: 'homeBanner/addNew',
  BANNER_REMOVE_MEDIA: 'homeBanner/removeMedia',
  BANNER_UPDATE_ORDER: 'homeBanner/updateOrder',
  /** End of banner */

  /** Knowledge Center */
  KNOWLEDGE_CENTER_ADD_MEDIA: 'knowledgeCenter/addNew',
  KNOWLEDGE_CENTRE_REMOVE_MEDIA: 'knowledgeCenter/removeMedia',
  KNOWLEDGE_CENTER_ALL_LIST: 'knowledgeCenter/getDetails',
  KNOWLEDGE_CENTER_TYPES: 'knowledgeCenter/getTypes',
  /** End of  Knowledge Center */

  /** Gallery */
  GALLERY_GET_ALL_LIST: 'galleryMedia/getAllList',
  GALLERY_ADD_NEW: 'galleryMedia/addNew',
  GALLERY_REMOVE_MEDIA: 'galleryMedia/removeMedia',
  /** End of Gallery */

  /** Latest Updates */
  ADD_LATEST_UPDATE: 'latestUpdate/addNew',
  REMOVE_LATEST_UPDATE: 'latestUpdate/remove',
  ALL_LATEST_UPDATES: 'latestUpdate/getAllList',
  /** End of  Latest Updates */

  /** Knowledge Center */
  WELCOME_VIDEOS_ADD_MEDIA: 'welcomeVideos/addNew',
  WELCOME_VIDEOS_REMOVE_MEDIA: 'welcomeVideos/removeMedia',
  WELCOME_VIDEOS_ALL_LIST: 'welcome-banner-list',
  /** End of  Knowledge Center */

  /** POWERBI */
  POWERBI_REPORT_DETAILS: '',
  POWERBI_ACCESS_TOKEN: 'GenerateToken',
  /** POWERBI */

  /** Employee Management */
  EMP_MNGT_GET_ALL_EMPLOYEE_LIST: 'empMgnt/getAllEmployeeList',
  EMP_MNGT_GET_EMPLOYEE_DETAILS: 'empMgnt/getFullDetails',
  EMP_MNGT_UPDATE_EMPLOYEE_STATUS: 'empMgnt/updateStatus',
  EMP_MNGT_UPDATE_ROLE: 'empMgnt/updateRoles',
  EMP_MNGT_UPDATE_PERSONAL_DETAILS: 'empMgnt/updatePersonalDetails',
  /** End of Employee Management */

  /** Notifications */
  GET_ALL_NOTIFICATIONS: 'notifications/yourList',
  MARK_READ_NOTIFICATIONS: 'notifications/markAsRead',
  GET_NOTIFICATION_TYPES: 'masters/getModulesList',
  /** Notifications */
  /** Claims APIS */
  GET_CLAIMS_LIST: '/getClaimList',
  GET_CLAIMS_DETAILS: '/getClaimDetails/',
  /** Claims APIS */
};
export const GOOGLE_MAP_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY ?? '';
export const GOOGLE_MAP_ID = process.env.REACT_APP_GOOGLE_MAP_ID ?? '';
